<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.params.title}}</el-breadcrumb-item>
            <el-breadcrumb-item>SEO</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" style="max-width: 600px; padding-top: 30px !important;">

        <div v-for="lang in languages" :key="`seo-page-${page.id}-lang-${lang}`">
          <el-divider content-position="center">{{lang | label}}</el-divider>

          <h2 style="text-align: left;margin-bottom: 12px;">Title</h2>
          <el-input v-model="webInfos['seo-title-'+page.id+'-'+lang]"></el-input>
          <div style="width: 100%;display:inline-block;"></div>
          <h2 style="text-align: left;margin-bottom: 12px;">Description</h2>
          <el-input v-model="webInfos['seo-description-'+page.id+'-'+lang]" type="textarea"></el-input>
        </div>

        <el-button class="btn-upload" style="top: 12px;" type="primary" size="mini" @click="submit">送出<i class="el-icon-upload el-icon--right"></i></el-button>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinLanguages],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      isLoading: false,
      webInfos: {}
    }
  },
  computed: {
    page () {
      return { id: this.$route.params.page, title: '' }
    }
  },
  methods: {
    submit () {
      console.log(`pageid=`, this.page.id)
      console.log(`this.webInfos=`, this.webInfos)
      var promiseList = []
      var payloads = []
      for (let obj of this.$store.state.webInfo.list) {
        if (!obj.ID.startsWith('seo')) continue
        console.log(`id=`, obj.ID)
        if (this.webInfos[obj.ID] === obj.Value) continue

        let payload = {
          ID: obj.ID,
          Value: this.webInfos[obj.ID]
        }
        payloads.push(payload)
        let promise = this.$services.webInfo.edit(this, payload)
        promiseList.push(promise)
      }

      if (promiseList.length === 0) {
        return alert('錯誤: 並未更動')
      }
      this.isLoading = true
      Promise.all(promiseList)
        .then(results => {
          let okCount = 0
          let errCount = 0

          for (var i = 0; i < results.length; i++) {
            let res = results[i]
            let ok = res && res.data && res.data.status === 'ok'
            okCount += ok ? 1 : 0
            errCount += !ok ? 1 : 0

            if (ok) {
              let payload = payloads[i]
              let idx = this.$store.state.webInfo.list.findIndex(o => o.ID === payload.ID)
              if (idx < 0) console.error('更新異常，找不到 webInfo，idx null')
              this.$store.state.webInfo.list[idx].Value = payload.Value
              this.$set(this.webInfos, payload.ID, payload.Value)
            }
          }

          if (errCount === 0) {
            this.$message({
              message: `更新成功`,
              type: 'success'
            })
          } else if (okCount === 0) {
            console.error(results)
            this.$message.error(`更新異常!`)
          } else {
            this.$message({
              message: `${okCount}筆資料更新成功, ${errCount}筆資料更新異常`,
              type: 'warning'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadData () {
      for (let obj of this.$store.state.webInfo.list) {
        if (obj.ID.startsWith('seo')) {
          this.$set(this.webInfos, obj.ID, obj.Value)
        }
      }
    }
  },
  created () {
    this.loadData()
  },
  filters: {
    label (str) {
      return {
        'Tw': '繁體中文',
        'Cn': '簡體中文',
        'En': '英文',
        'Jp': '日文'
      }[str] || '未知語言'
    }
  }
}
</script>
